export default (session, { payload }) => {
    const { Sector, Hall } = session;
    const { sectors: { items } } = payload;
    const hall = Hall.all().first();

    if (!hall) {
        return;
    }

    items.forEach((sector) => {
        Sector.create(sector);
        hall.sectors.add(sector.id);
    });
};
